const permissions = {
  VIEW_PATIENTS: 'view:patients',
  VIEW_HIPPA_CERTIFIED: 'view:hippa-certified',
  VIEW_METRICS: 'view:metrics',
  VIEW_PROVIDERS: 'view:providers',
  VIEW_CLINICS: 'view:clinics',
  VIEW_APPOINTMENTS: 'view:appointments',
  VIEW_EMR: 'view:emr',
  VIEW_MEDICAL_RECORDS: 'view:medical-records',
  EDIT_SCHEDULE: 'edit:schedule',
  EDIT_FEE: 'edit:fee',
  EDIT_PATIENTS: 'edit:patients',
  EDIT_REASONS: 'edit:appointment:reason-for-visit',
  SELECT_QUESTIONNAIRE: 'select:appointment:questionnaire',
  EDIT_WAITING_ROOM: 'edit:appointment:waiting-room-settings',
  EDIT_TOOLS_PATIENT: 'edit:tools:patient',
  EDIT_TOOLS_PROVIDER: 'edit:tools:provider',
  EDIT_DISCHARGE_SUMMARY: 'edit:discharge-summary',
  SHOW_DEVICES: 'show:devices',
  SHOW_APPOINTMENT_QUESTIONNAIRE: 'show:appointment:questionnaire',
  SHOW_APPOINTMENT_REASONS: 'show:appointment:reason-for-visit',
  SELECT_REASONS_FOR_VISIT: 'select:reason:visit',
  ENTER_APPOINTMENT: 'enter:appointment',
  GENERATE_REPORTS: 'generate:reports',
  CC_EXAM: 'cc:exam',
  CC_HOME: 'cc:home',
  SOAP_NOTE: 'soap:note',
  MEDICAL_IMAGES: 'medical:images',
  INVITE_PATIENT: 'invite:patient',
  UPLOAD_CSV: 'upload:csv',
  UPDATE_QUESTIONNAIRE: 'update:questionnaire',
  EASY_SCRIPT_ACCOUNT: 'easy:script:account',
  ACCEPT_INSURANCE: 'accept:insurance',
  SCHEDULER_CONTROLLER: 'scheduler:controlled',
  VIEW_BOOKING: 'view:booking',
  MANAGE_INVENTORY: 'manage:inventory',
  ASSIGN_PATIENT_RPM: 'assign:patientToRPM',
  MANAGE_ORDERS: 'manage:orders',
  URGENT_CARE: 'take-part:urgent-care-appointment',
  PRIMARY_CARE: 'take-part:primary-care-appointment',
  PROVIDER_WAITING_ROOM: 'use:provider-waiting-room',
  MANAGE_RPM: 'manage:rpm',
  MEDICAL_MEDIA: 'view:medical-media',
  MANAGE_APPOINTMENTS: 'edit:appointments',
  MANAGE_MEDICAL_RECORDS: 'manage:medical-records',
  PATIENT_DEPENDENT: 'patient:dependents',
  MANAGE_CANCEL_APPOINTMENTS: 'cancel:appointment',
};

export default permissions;
